import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth-routes/admin/hierarchies')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/hierarchy' })
  },
})
